module.exports = __webpack_public_path__ + "img/green_005.c3aba4df.png";